import styled from 'styled-components';

import { PriceBillsWrapper } from '@spa/shared/components/Search/Card/OfferCard/styles';

export const WrapperLink = styled.a`
  & > * {
    text-decoration: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 285px;
  min-height: 257px;
  box-shadow: 0px 10px 20px rgba(34, 66, 81, 0.3);
  border-radius: 12px;
  background: ${props => props.theme.card.background};

  ${props =>
    props.isMobile &&
    `
      flex-direction: row;
      width: 346px;
      height: 160px;
      min-height: 0px;
    `}
`;

export const MediaWrapper = styled.div`
  width: 100%;
  position: relative;

  img {
    width: 100%;
    height: 160px;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
  }

  ${props =>
    props.isMobile &&
    `
      width: 160px;

      img {
        width: 160px;
        border-radius: 12px 0 0 12px;
      }
    `}
`;

export const InfoWrapper = styled.div`
  padding: ${props => props.theme.space(1)} ${props => props.theme.space(3)} ${props => props.theme.space(3)};

  h2 {
    font-size: ${props => props.theme.rem(16)};

    ${props =>
      props.isMobile &&
      `
        margin-right: 30px;
        width: 140px;
        height: 40px;
        overflow: hidden;
        line-clamp: 2;
        text-decoration: none;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
    `}
  }

  ${props =>
    props.isMobile &&
    `
      padding: ${props.theme.space(3)} ${props.theme.space(2)};

      ${PriceBillsWrapper} {
        flex-direction: column;
        align-items: flex-start;

        > span {
          margin: ${props.theme.space(2)} 0;
        }
      }
    `}
`;
